export const getContinuationPagesData = (pagesData, key?: string) =>
    pagesData?.pages?.flatMap((page) => {
        if (key && page?.[key]) {
            return page?.[key];
        }
        return page;
    });
